module.exports = __webpack_public_path__ + "img/banke.503817dd.png";